import React, { useEffect, useRef } from 'react';

const BinaryRain = ({ density = 1, theme = 'light' }) => {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const fontSize = window.innerWidth <= 768 ? 12 : 10;
    let columns = [];
    const resizeCanvas = () => {
      const dpr = window.devicePixelRatio || 1;
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      canvas.style.width = `${window.innerWidth}px`;
      canvas.style.height = `${window.innerHeight}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const count = Math.max(1, Math.floor((window.innerWidth / (fontSize * 2.2)) * density));
      columns = Array.from({ length: count }, (_, index) => ({ x: index * (window.innerWidth / count), y: Math.random() * window.innerHeight, speed: 1 + Math.random() * .7 }));
    };
    resizeCanvas();
    const colors = theme === 'light' ? { fade: 'rgba(245, 247, 251, .025)', char: 'rgba(8, 124, 136, .62)', glow: 'rgba(8, 124, 136, .58)' } : { fade: 'rgba(12, 16, 23, .08)', char: 'rgba(74, 215, 220, .32)', glow: 'rgba(74, 215, 220, .28)' };
    const draw = () => {
      ctx.fillStyle = colors.fade;
      ctx.fillRect(0, 0, window.innerWidth, window.innerHeight);
      ctx.font = `${fontSize}px ui-monospace, SFMono-Regular, Menlo, monospace`;
      ctx.textBaseline = 'top';
      columns.forEach((column) => {
        ctx.fillStyle = colors.char;
        ctx.shadowBlur = 3;
        ctx.shadowColor = colors.glow;
        ctx.fillText(Math.random() > .5 ? '1' : '0', column.x, column.y);
        column.y = column.y > window.innerHeight ? 0 : column.y + fontSize * column.speed;
      });
      ctx.shadowBlur = 0;
    };
    const interval = window.setInterval(draw, 55);
    window.addEventListener('resize', resizeCanvas);
    return () => { window.clearInterval(interval); window.removeEventListener('resize', resizeCanvas); };
  }, [density, theme]);
  return <canvas ref={canvasRef} className="binary-rain" aria-hidden="true" />;
};
export default BinaryRain;
